<template>
  <a-form-model
    class="form"
    :model="form"
    ref="editForm"
    :rules="rules"
    label-position="top"
    size="mini"
  >
    <a-form-model-item label="大标题" prop="title">
      <a-input v-model="form.title" placeholder="直播列表大标题"></a-input>
    </a-form-model-item>
    <a-form-model-item label="直播列表">
      <drag-zone class="item-list" :list="items">
        <template v-slot="{ item, index }">
          <div class="live-item">
            <div
              class="live-img"
              :style="{ backgroundImage: `url(${item.cover}` }"
            ></div>
            <div class="live-info">
              <div class="live-title">{{ item.title }}</div>
              <div class="live-desc">{{ item.url }}</div>
              <div class="live-detail">
                {{ item.type == 1 ? item.start + "至" + item.end : "" }}
              </div>
            </div>
            <div class="live-btn">
              <a-icon
                type="form"
                class="icon-edit-outline"
                @click="editLive(index)"
              />
              <a-icon
                type="delete"
                class="icon-delete"
                @click="remove(index)"
              />
            </div>
          </div>
        </template>
      </drag-zone>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加直播</div>
      </div>
    </a-form-model-item>
    <template v-if="form.more">
      <a-form-model-item label="卡片“更多”文字">
        <a-input v-model="form.more.title"></a-input>
      </a-form-model-item>
      <a-form-model-item label="卡片“更多”链接">
        <a-input v-model="form.more.url"></a-input>
      </a-form-model-item>
    </template>
    <a-form-model-item label="标题加粗">
      <a-switch v-model="form.bold"></a-switch>
    </a-form-model-item>
    <!-- <a-form-model-item label="卡片分割线">
      <a-switch v-model="form.itemLine"></a-switch>
    </a-form-model-item> -->
    <a-form-model-item label="标题分割线">
      <a-switch v-model="form.topLine"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="图片高度">
      <a-input type="number" v-model="form.height"></a-input>
    </a-form-model-item>
    <a-form-model-item label="图片圆角">
      <a-input type="number" v-model="form.borderRadius"></a-input>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        class="color-picker shadow"
        default-color="transparent"
        v-model="form.backgroundColor"
      ></colorPicker>
    </a-form-model-item>
    <template v-if="form.content">
      <a-form-model-item label="内容内层间距" v-if="form.content.padding">
        <a-space>
          <a-input
            type="number"
            class="inline-input"
            placeholder="上"
            v-model="form.content.padding.top"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="下"
            v-model="form.content.padding.bottom"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="左"
            v-model="form.content.padding.left"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="右"
            v-model="form.content.padding.right"
          ></a-input>
        </a-space>
      </a-form-model-item>
      <a-form-model-item label="内容圆角">
        <a-input type="number" v-model="form.content.borderRadius"></a-input>
      </a-form-model-item>
      <a-form-model-item label="内容背景色">
        <colorPicker
          class="color-picker top shadow"
          default-color="rgba(11, 121, 255, 0.8)"
          v-model="form.content.backgroundColor"
        ></colorPicker>
      </a-form-model-item>
    </template>
    <a-form-model-item label="是否在首页显示">
      <a-switch v-model="form.isShow"></a-switch>
    </a-form-model-item>
    <a-modal
      title="直播配置"
      width="400px"
      :visible.sync="ds"
      @ok="confirmLive"
      @cancel="hideDialog"
    >
      <a-form-model ref="liveForm" :model="live" :rules="liveRules" v-if="live">
        <a-form-model-item label="直播来源" prop="type">
          <a-radio-group v-model="live.type">
            <a-radio :value="1">从建好的直播中选</a-radio>
            <a-radio :value="2">自定义直播</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="选择直播" v-if="live.type == 1" prop="detail">
          <a-select
            v-model="live.detail"
            allowClear
            placeholder="输入直播标题搜索"
            show-search
            label-in-value
            :filter-option="false"
            :not-found-content="loading ? undefined : null"
            :default-active-first-option="false"
            @search="searchLive"
            @change="liveChange"
          >
            <a-select-option v-for="item in liveList" :key="item.id">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <template v-else-if="live.type == 2">
          <a-form-model-item label="直播标题" prop="title">
            <a-input v-model="live.title" placeholder="直播标题"></a-input>
          </a-form-model-item>
          <a-form-model-item label="直播地址" prop="url">
            <a-input
              v-model="live.url"
              placeholder="请输入直播网页地址"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="开始时间" prop="start">
            <a-date-picker
              show-time
              value-format="yyyy-MM-DD HH:mm:ss"
              v-model="live.start"
              placeholder="选择直播开始时间"
            >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="结束时间" prop="end">
            <a-date-picker
              show-time
              value-format="yyyy-MM-DD HH:mm:ss"
              v-model="live.end"
              placeholder="请选择直播结束时间"
            >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="直播封面" prop="cover">
            <cl-upload v-model="live.cover"></cl-upload>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
  </a-form-model>
</template>

<script>
import dragZone from "../drag-zone";
import clUpload from "../cl-upload";
import { clone, randomString, debounce } from "../../common/js/tool";

export default {
  name: "live-edit",
  components: {
    clUpload,
    dragZone,
  },
  inject: ["build"],
  props: {
    value: Object,
  },
  data() {
    this.lastFetchId = 0;
    this.searchLive = debounce(this.searchLive, 500);
    return {
      form: {},
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      items: [],
      live: null,
      index: null,
      liveList: [],
      loading: false,
      liveRules: {
        type: [
          { required: true, message: "请选择直播来源", trigger: "change" },
        ],
        detail: [{ required: true, message: "请选择直播", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        url: [{ required: true, message: "请输入直播地址", trigger: "blur" }],
        start: [
          { required: true, message: "请选择直播开始时间", trigger: "change" },
        ],
        end: [
          { required: true, message: "请输入直播结束时间", trigger: "change" },
        ],
        cover: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("请上传直播封面图"));
              }
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ds: {
      get() {
        return !!this.live;
      },
      set(val) {
        !val && this.hideDialog();
      },
    },
    // activity() {
    //   return this.$store.getters.activity;
    // },
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    searchLive(val) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.liveList = [];

      this.loading = true;
      let url = `/activity/activity-video?filter[activity_id]=${this.id}`;
      if (val) {
        url += `&filter[detail][like]=${val}`;
      }
      let build = this.build;
      if (build.isActivity && build.conf) {
        url += `&filter[activity_id]=${build.conf.id}`;
      }
      this.$axios({
        url,
        loadingText: false,
      })
        .then((res) => {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
          }

          let list = res.data;
          list.forEach((item) => {
            try {
              let detail = JSON.parse(item.detail);
              item.title = detail.title;
            } catch (e) {
              console.log(e);
            }
          });
          this.liveList = list;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.liveList = [];
        });
    },
    liveChange(value) {
      if (this.live.detail) {
        this.live.detail.info = this.liveList.find(
          (item) => item.id == value.key
        );
      }

      this.liveList = [];
      this.loading = false;
      this.searchLive(value);
    },
    confirmLive() {
      this.$refs.liveForm.validate((flag) => {
        if (flag) {
          let item;
          let live = this.live;
          if (live.type == 1) {
            let detail = live.detail.info;
            item = {
              type: detail.type,
              sourceType: live.type,
              id: detail.id,
            };
            let info = {};
            try {
              info = JSON.parse(detail.detail);
            } catch (e) {
              console.error(e);
            }
            item = Object.assign(item, info);
          } else {
            item = {
              sourceType: live.type,
              title: live.title,
              url: live.url,
              start: live.start,
              end: live.end,
              cover: live.cover,
            };
          }
          //编辑
          let items = this.items;
          if (live.key) {
            item.key = live.key;
            this.$set(items, this.index, item);
          } else {
            // 新增
            item.key = `live_${randomString(6)}`;
            items.push(item);
          }
          this.hideDialog();
        }
      });
    },
    hideDialog() {
      this.live = null;
      this.index = null;
    },
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        let list = temp.list;
        temp.list.forEach((item) => {
          if (!item.key) {
            item.key = `live_${randomString(6)}`;
          }
        });
        this.getLiveInfo(list);
        this.items = list;
        delete temp.list;
        this.form = temp;
      }
    },
    //实时获取直播信息
    getLiveInfo(list) {
      let ids = [];
      list.forEach((item) => {
        if (item.type == 1) {
          ids.push(item.id);
        }
      });
      if (ids.length > 0) {
        this.$axios({
          url: "/activity/activity-video/list",
          params: {
            ids: ids.join(","),
          },
          loadingText: false,
        }).then((res) => {
          let items = this.items;
          res.forEach((a) => {
            let detail = {};
            try {
              detail = JSON.parse(a.detail);
            } catch (e) {
              console.log(e);
            }
            let index = items.findIndex((t) => t.id == a.id);
            if (index >= 0) {
              let item = items[index];
              item.title = detail.title;
              item.url = detail.url;
              item.record = detail.record;
              item.start = detail.start;
              item.end = detail.end;
              item.cover = detail.cover;
              this.$set(items, index, item);
            }
          });
        });
      }
    },
    editLive(index) {
      let item = this.items[index];
      let live = clone(item);
      live.detail = { key: live.id, label: live.title, info: clone(live) };
      live.type = live.type || 2;
      this.live = live;
      this.index = index;
    },
    addItem() {
      this.live = { type: 1 };
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      let list = clone(this.items);
      temp.list = list;
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      if (!this.form.title) {
        msg = "请输入直播列表大标题";
      }
      return msg;
    },
  },
};
</script>

<style scoped lang="less">
.live-item {
  position: relative;
  padding: 10px;
  background-color: var(--back-light-color);
  border-bottom: 1px solid var(--back-white-color);
  &:hover {
    .live-btn {
      display: flex;
    }
  }
}
.live-img {
  height: 120px;
  background: center no-repeat;
  background-size: cover;
}
.live-info {
  margin-top: 10px;
  line-height: 1;
}
.live-desc {
  margin-top: 6px;
  color: var(--tip-font-color);
  line-height: 1.3;
  word-break: break-word;
}

.live-detail {
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-font-color);
}
.live-btn {
  display: none;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 10px;
  height: 40px;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 1)
  );
  font-size: 20px;
  color: var(--text-font-color);
  cursor: pointer;
}

.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
